<template>
  <div @click="handleCardClick">
  <el-card shadow="hover" class="trade-card">
    <img :src="IMAGE_BASE_URL + trade.previewImageName" class="image">
    <div style="padding: 10px 10px 5px 10px;">
      <el-link class="title">{{trade.title}}</el-link>
      <div class="sub-title">{{trade.content}}</div>
      <div class="footer flex">
        <div class="flex-1">
          <i class="custom-icon icon-coins"></i>
          <span>已提交意向金{{trade.intention}}元</span>
        </div>
        <div class="tag">
          <span class="icon"><i class="custom-icon icon-eye"/><span>{{trade.readCount}}</span></span>
          <span class="icon" style="margin-left: 5px"><i class="custom-icon icon-link"/><span>{{trade.dockingCount}}</span></span>
        </div>
      </div>
    </div>
  </el-card>
  </div>
</template>

<script>
  import { IMAGE_BASE_URL, Menu, Trade } from '../util/constants'
  export default {
    name: 'card-trade',
    props: {
      trade: Object
    },
    data() {
      return {
        IMAGE_BASE_URL
      }
    },
    methods: {
      handleCardClick() {
        if (this.trade.type === Trade.Demand) {
          this.$router.push({
            path: `/demand/detail/${this.trade.id}`,
            params: {
              from: Menu.Home
            }
          })
        }
        if (this.trade.type === Trade.Supply) {
          this.$router.push({
            path: `/supply/detail/${this.trade.id}`,
            params: {
              from: Menu.Home
            }
          })
        }
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .trade-card {
    cursor: pointer;
    & >>> .el-card__body {
      padding: 0;
    }
    .time {
      font-size: 14px;
      color: #999;
    }
    .bottom {
      margin-top: 13px;
      line-height: 12px;
    }
    .image {
      /*width: 100%;
      height: 150px;
      display: block;
      padding: 0;*/
      margin: 0 auto;
      width: 180px;
      height: 180px;
      display: block;
      padding: 15px;
    }

    .title {
      font-size: 16px;
      font-weight: bold;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      cursor: pointer;
    }

    .sub-title {
      margin-top: 5px;
      font-size: 14px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      color: #999;
    }

    .footer {
      font-size: 14px;
      margin-top: 5px;
      color: #999;
      .icon-coins {
        position: relative;
        top: 5px;
      }
      .tag {
        .icon {
          position: relative;
          bottom: 3px;
        }
        .icon-eye {
          top: 8px;
          position: relative;
          margin-right: 3px;
        }
        .icon-link {
          top: 6px;
          position: relative;
          margin-right: 3px
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/card-trade.vue